import 'bootstrap/dist/css/bootstrap.min.css';
import '../App.css';
import { Routes, Route } from 'react-router-dom';
import { Link } from 'react-router-dom';

/* 라우트 */
import Search from '../routes/Search';
import Fsearch from '../routes/Fsearch';
import Ai from '../routes/Ai';
import Experience from '../routes/Experience';
import Reservation from '../routes/Reservation';

/* 컴포넌트 */
import Header from '../components/Header';
import Banner from '../components/Banner';
import Footer from '../components/Footer';

/* 아이콘 */
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import { FaStar, FaMapMarkerAlt } from "react-icons/fa";
import { BsArrowRight, BsPlusSquare } from "react-icons/bs";

const Main = () => {
    return (
        <div className="App">
          {/* 헤더 */}
          <Header />
          {/* 컨텐츠 */}
          <Routes>
            <Route path='/' element={
              <>
                {/* 검색창 */}
                <Search />
                <div className='contents'>
                  {/* 배너 */}
                  <Banner />
                  <div id='box2_wrap'>
                    <div className='box2'>
                      <img src='https://kimsikyoung.github.io/images/HaiRound/img/cut.png' alt='logo'></img>
                      <p>헤어컷</p>
                    </div>
                    <div className='box2'>
                      <img src='https://kimsikyoung.github.io/images/HaiRound/img/perm.png' alt='logo'></img>
                      <p>펌</p>
                    </div>
                    <div className='box2'>
                      <img src='https://kimsikyoung.github.io/images/HaiRound/img/color.png' alt='logo'></img>
                      <p>염색</p>
                    </div>
                    <div className='box2'>
                      <img src='https://kimsikyoung.github.io/images/HaiRound/img/clinic.png' alt='logo'></img>
                      <p>클리닉</p>
                    </div>
                  </div>
    
                  {/* 가까운 미용실 찾기 */}
                  <div className='box3'>
                    <p>가까운 미용실찾기<MdOutlineKeyboardArrowRight className='arrow' /></p>
                    <div className='box3_img'>
                      <img src='https://kimsikyoung.github.io/images/HaiRound/img/around_map.png' alt='미용실찾기' width='100%' height='100%' />
                    </div>
                  </div>
    
                  {/* 다시 방문 */}
                  <div className='box3-1'>
                    <p>그때 그 미용실, 다시 방문하시겠어요?<MdOutlineKeyboardArrowRight className='arrow' /></p>
                    <div className='box3-1_content'>
                      <p className='fl'><BsPlusSquare className='plus' />예약</p>
                      <p><BsPlusSquare className='plus' />문의</p>
                      <p className='shop'>타마시헤어</p>
                      <p className='dist'><FaMapMarkerAlt />1.2km</p>
                      <p className='spot'>경기도 평택시 비전동</p>
                    </div>
                  </div>
    
                  {/* 디자이너 특가 할인 */}
                  <div className='box4'>
                    <p>Designer!<em>나만 알기 아까운 디자이너 추천</em><MdOutlineKeyboardArrowRight className='arrow2' /></p>
                    <div className='box4_img'>
                      <p></p>
                      <p></p>
                      <p></p>
                    </div>
                    <div className='box4_content'>
                      <p>실장 송강(<FaStar className='star' /> 4.6)<br /><em className='price'>펌<em>39,000원</em></em></p>
                      <p>원장 시경(<FaStar className='star' /> 5.0)<br /><em className='price'>염색<em>23,000원</em></em></p>
                      <p>팀장 은우(<FaStar className='star' /> 4.3)<br /><em className='price'>매직<em>79,000원</em></em></p>
                    </div>
                    <div className='box4_go'>
                      <p>헤어라운드 특가 할인 더보기</p><BsArrowRight className='Rarrow' />
                    </div>
                  </div>
    
                  {/* 요즘 뜨는 스타일 */}
                  <div className='box5'>
                    <p>요즘뜨는 스타일<MdOutlineKeyboardArrowRight className='arrow' /></p>
                    <div className='box5_imgs'>
                      <div className='box5_img1'>
                        <p></p>
                      </div>
                      <div className='box5_img2'>
                        <p></p>
                        <p></p>
                      </div>
                    </div>
                    <div className='box5_content'></div>
                  </div>
                </div>
              </>
            } />
            <Route path='/Fsearch' element={<Fsearch />} />
            <Route path='/Ai' element={<Ai />} />
            <Route path='/Experience' element={<Experience />} />
            <Route path='/Reservation' element={<Reservation />} />
          </Routes>
          {/* 푸터 */}
          <Footer />
        </div>
      );
}

export default Main;
